import React, { Component }     from 'react';
import AuthService              from 'services/auth.service';
import ClaimsService            from 'services/claims.service';
import { claimDetailsElements } from 'components/ClaimDetails/ClaimDetailsElements';

const colorHash   = { 'Approved': 'success', 'Rejected': 'primary', 'Pending Submissions': 'warning', 'Pending Approval': 'grey', 'Paid': 'success' };
const statusHash  = { 'approved': 'Approved', 'not_submitted': 'Pending Submissions', 'draft': 'Pending Submissions', 'under_review': 'Pending Submissions', 'pending': 'Pending Approval', 'under_approval_review': 'Pending Approval', 'rejected': 'Rejected' };
const catHash     = { 'general': 'Medical', 'gp': 'Medical', 'specialist': 'Specialist', 'dental': 'Dental', 'optical': 'Optical', 'ehs': 'EHS' };

class ClaimPrint extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      claim: null,
      error_msg: null
    };
  }

  reloadList() {
    if (this.state.id) {
      ClaimsService.show(this.state.id).then(
        (data) => {
          const status = data.claim.paid ? 'Paid' : statusHash[data.claim.status];

          this.setState({
            claim:    data.claim,
            status:   status,
            color:    colorHash[status],
            category: catHash[data.claim.category]
          });

          setTimeout(window.print, 1000);
        },
        (error) => {
          console.log(error.response);

          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          } else if (error.response.status === 404) {
            this.setState({
              error_msg: 'Claim ID: ' + this.state.id + ' not found'
            });
          }
        }
      );
    }
  };

  componentDidMount() {
    const id = window.location.pathname.match(/\/print-claim\/(\d+)/)[1];

    this.setState({
      id: id
    }, this.reloadList);
  }

  render() {
    return (
      <div className="bg-white p-8">
        <div className="d-sm-flex justify-content-between align-items-end">
          <h1 className="mb-4">Claim Details</h1>
        </div>

        <div className="font-size-10">
          <span className="text-danger">{ this.state.error_msg }</span>

          { this.state.claim &&
            claimDetailsElements({
              data:     this.state.claim,
              status:   this.state.status,
              color:    this.state.color,
              category: this.state.category
            })
          }
        </div>
      </div>
    )
  }
}

export default ClaimPrint;